import React, { Component } from "react";
import { Button } from "reactstrap";

export default class ReuploadOfflineApproval extends Component {

    render() {
        const { oet, run, open_modal} = this.props
        const cpo = oet.customer_purchase_order;
        const customer_team = cpo ? cpo.customer_teams : null;
        let expired_days = run.oet_item_expired_days;
        let condition = null;
        
        condition = expired_days ? expired_days > 0 && expired_days <= 30 : false
        if (customer_team !== 1) {
            expired_days = cpo.expired_days
            condition = expired_days < 90 && expired_days > 60
        }
        const button = condition ? <React.Fragment>
            <Button
                icon="upload"
                color="primary"
                type="button"
                onClick={() => open_modal()}
            >
                Reupload offline approval
            </Button>
        </React.Fragment> : null

        return button
    }
}